import { css } from '@emotion/css'
import { fontSize, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  image: css({
    display: 'block',
    margin: shorthandHelper([0, 'auto', spacing.large]),
  }),

  title: css({
    margin: 0,
    textAlign: 'center',
    fontSize: fontSize.extraLarge,
  }),

  effectiveDate: css({
    margin: shorthandHelper([spacing.extraLarge, 0]),
  }),

  heading: css({
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.large,
    margin: shorthandHelper([spacing.medium, 0]),
  }),

  orderedList: css({
    listStyle: 'none',
    padding: 0,

    li: {
      margin: 'inherit',
    },
  }),

  notification: css({
    marginBottom: spacing.large,

    p: {
      marginTop: 0,
    },

    'p:last-child': {
      marginBottom: 0,
    },

    b: {
      fontWeight: fontWeight.medium,
    },
  }),
}

export default styles
